/* eslint-disable object-curly-newline */
export default class RenderView {
  constructor(elem) {
    this.render = elem.querySelector('.js-render');

    if (!this.render) { return; }

    this.debug = elem.querySelector('.js-debug');
    const options = elem.querySelectorAll('.js-renderview-options');

    // SET IN FOR LOOP
    this.options = {};

    // TEMP RENDER OBJECT
    this.renders = [
      { opstelling: 'Rechte opstelling', stijl: 'default', image: 'DMG_Jochem_3-Meter.jpg', indeling: 'default' },
      { opstelling: 'Eiland opstelling', stijl: 'default', image: 'DMG_Jochem_Eilandkeuken.jpg', indeling: 'default' },
      { opstelling: 'Hoek opstelling', stijl: 'default', image: 'DMG_Jochem_3x3-A.jpg', indeling: 'default' },
      { opstelling: 'Hoek opstelling', stijl: 'default', image: 'DMG_Jochem_3x3-B.jpg', indeling: 'gespiegeld' },
      { opstelling: 'Hoek opstelling', stijl: 'eiken', image: 'DMG_Jochem_3x3-B-Eiken.jpg', indeling: 'gespiegeld' },
      { opstelling: 'Hoek opstelling', stijl: 'wit-hoogglans', image: 'DMG_Jochem_3x3-B-Wit-Hoogglans.jpg', indeling: 'gespiegeld' },
      { opstelling: 'Hoek opstelling', stijl: 'wit-mat', image: 'DMG_Jochem_3x3-B-Wit-Mat.jpg', indeling: 'gespiegeld' },
      { opstelling: 'Hoek opstelling', stijl: 'wit-semigloss', image: 'DMG_Jochem_3x3-B-Wit-SemiGloss.jpg', indeling: 'gespiegeld' },
    ];

    this.updateRender = this.updateRender.bind(this);
    this.searchRender = this.searchRender.bind(this);

    if (options.length) {
      for (let i = 0; i < options.length; i++) {
        const element = options[i];
        const name = element.dataset.optionName;

        const radios = element.querySelectorAll(`input[type="radio"][name="${name}"]`);

        if (radios.length) {
          this.options[name] = this.getRadioValue(name);

          for (let j = 0; j < radios.length; j++) {
            const radio = radios[j];
            radio.addEventListener('change', () => {
              this.options[name] = this.getRadioValue(name);
              this.updateRender();
            });
          }
        }

        this.updateRender();
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getRadioValue(name) {
    const radio = document.querySelector(`input[name="${name}"]:checked`);
    return (radio) ? radio.value : undefined;
  }

  updateRender() {
    const render = this.renders.find(this.searchRender);
    if (!render) {
      this.debug.innerHTML = `Geen match gevonden 🥺 er zijn ${this.renders.length} juiste combinaties ingesteld. Default wordt weergeven.`;
      this.debug.classList.remove('is--good');
      this.render.src = './img/renders/DMG_Jochem_Origineel.jpg';
      return;
    }

    this.debug.innerHTML = 'Match gevonden! 🎉';
    this.debug.classList.add('is--good');
    this.render.src = `./img/renders/${render.image}`;
  }

  searchRender(render) {
    // eslint-disable-next-line max-len
    return render.opstelling === this.options.opstelling && render.stijl === this.options.stijl && render.indeling === this.options.indeling;
  }
}
